import Vue from "vue";
import Vuex from "vuex";

import chat from "@/store/chat";

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    siteInfo: {},
    webInfo: {},
    // 岗位检索是否带地图
    searchWithLocation: false,
    tabbar: [],
    sceneId: undefined,
    recId: undefined,
    shareConfig: [],
    editRegionList: [],
    filterRegionList: [],
    cates: {},
    chatList: [],
    hasCompanyStyle: false,
    myRecruitIndex: 0,
  },
  mutations: {
    SET_VALUE(state, payload) {
      const { key, value } = payload;
      state[key] = value;
    },
    setShareConfig(state, payload) {
      state.shareConfig = payload;
    },
    setSearchWithLocation(state, payload) {
      this.state.searchWithLocation = payload;
    },
    setSiteInfo(state, payload) {
      state.siteInfo = payload;
      // 设置直聊
      state.tabbar = [
        {
          iconPath: "/static/images/icons/home/home.png",
          selectedIconPath: "/static/images/icons/home/home-active.png",
          text: "首页",
          pagePath: "/pages/index/index",
        },
        {
          iconPath: "/static/images/icons/home/job.png",
          selectedIconPath: "/static/images/icons/home/job-active.png",
          text: "公告",
          pagePath: "/pages/notice/list",
        },
        {
          iconPath: "/static/images/icons/home/recruit.png",
          selectedIconPath: "/static/images/icons/home/recruit-active.png",
          text: "职位",
          pagePath: "/pages/recruit/list",
        },
        {
          iconPath: "/static/images/icons/home/my.png",
          selectedIconPath: "/static/images/icons/home/my-active.png",
          text: "我的",
          pagePath: "/pages/my/my",
        },
      ];
    },
    setNoReadNumTabbar(state, noReadNum) {
      state.tabbar = [
        {
          iconPath: "/static/images/icons/home/home.png",
          selectedIconPath: "/static/images/icons/home/home-active.png",
          text: "首页",
          pagePath: "/pages/index/index",
        },
        {
          iconPath: "/static/images/icons/home/job.png",
          selectedIconPath: "/static/images/icons/home/job-active.png",
          text: "公告",
          pagePath: "/pages/notice/list",
        },
         {
          iconPath: "/static/images/icons/home/recruit.png",
          selectedIconPath: "/static/images/icons/home/recruit-active.png",
          text: "职位",
          pagePath: "/pages/recruit/list",
        },
        {
          iconPath: "/static/images/icons/home/my.png",
          selectedIconPath: "/static/images/icons/home/my-active.png",
          text: "我的",
          pagePath: "/pages/my/my",
        },
      ];
    },

    CHANGE_SET_VALUE: (state, { key, value }) => {
      if (state.hasOwnProperty(key)) {
        state[key] = value;
      }
    },
    setEditRegionList(state, payload) {
      state.editRegionList = payload;
    },
    setFilterRegionList(state, payload) {
      state.filterRegionList = payload;
    },
    setCates(state, payload) {
      state.cates = payload;
    },
    // 聊天页面列表数据
    setChatList(state, payload) {
      state.chatList = payload;
    },
  },
  action: {
    setValue({ commit }, data) {
      return new Promise((resolve) => {
        commit("CHANGE_SET_VALUE", data);
        resolve();
      });
    },
  },
});

export default store;
